/* global jQuery, DOMParser, alert */

import { Module } from 'wrapper6'
import { mttAjax } from 'utils/_mtt_ajax'
import GA4Tracking from 'app/GA4/utils/ga4-tracking'

export default class SingleProductHandler extends Module {
  ready () {
    this.singleProductForm = document.querySelector('.product-type-simple')
    if (!this.singleProductForm) return

    this.body = document.querySelector('body')
    this.header = document.querySelector('.mtt-header')
    this.miniCart = document.querySelector('.menu-mini-cart')
    this.overlay = document.getElementById('cart-overlay')

    this.quantityInput = this.singleProductForm.querySelector('input[name="quantity"]')

    if(this.quantityInput) {
      this.quantityInput.addEventListener('input', () => {
        this.handleQuantity();
      })
    }

    this.perMeterInput = this.singleProductForm.querySelector('#mtt-amount-per-meter-field')
    if (this.perMeterInput) {
      this.perMeterInput.addEventListener('input', () => {
        this.handlePerMeter()
      })
    }

    this.button = document.querySelector('[name="add-to-cart"]')
    if (this.button) {
      this.button.addEventListener('click', async () => {
        await this.addToCart()
      })
    }
  }

  handlePerMeter () {
    let perMeter = parseFloat(this.perMeterInput.dataset.perMeter)
    let meter = this.perMeterInput.value
    if(meter !== 0 && perMeter % 3 !== 0) {
      meter = parseInt(perMeter / 3) + (perMeter % 3)
    }
    this.quantityInput.value = Math.ceil(this.perMeterInput.value * meter)

    this.handleQuantity();
  }

  handleQuantity() {
    this.price = parseFloat(this.singleProductForm.querySelector('input[name="price"]').value)
    this.currency = this.singleProductForm.querySelector('.mtt-price-wrap__price').querySelector('.woocommerce-Price-currencySymbol')
    this.priceHtml = this.singleProductForm.querySelector('.mtt-price-wrap__total').querySelector('bdi')

    const price = (this.price * parseInt(this.quantityInput.value)).toFixed(2)
    this.priceHtml.innerHTML = price.replace('.', ',') + '&nbsp;'
    this.priceHtml.appendChild(this.currency)

    this.hiddenPrice = document.querySelector('#full-amount')
    if (this.hiddenPrice) {
      this.hiddenPrice.value = price
      this.hiddenPrice.dispatchEvent(new Event('change'))
    }
  }

  async addToCart () {
    this.button.classList.add('loading')

    const data = {
      action: 'add_product_to_cart',
      product_id: this.button.value,
      quantity: this.quantityInput.value
    }

    mttAjax('add_product_to_cart', data, this.callbackAddToCart.bind(this))
  }

  callbackAddToCart (response) {
    this.button.classList.remove('loading')
    if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
    if (response.success === true) {
      const miniCartHtml = new DOMParser().parseFromString(response.data.mini_cart_html, 'text/html')
      document.querySelector('.menu-mini-cart').innerHTML = miniCartHtml.querySelector('.menu-mini-cart').innerHTML

      this.body.classList.add('header-scrolled')
      this.header.classList.add('mtt-header--scrolled')
      this.miniCart.classList.remove('closed')
      this.overlay.classList.add('show')
      this.miniCart.classList.remove('empty')

      const didYouMissPopupElement = document.getElementById('did-you-miss-popup')
      if (didYouMissPopupElement) {
        window.openModal(didYouMissPopupElement)
      }

      // GA4
      if (response.data.hasOwnProperty('ga_add_to_cart_item')) {
        GA4Tracking.pushEvent('add_to_cart', [response.data.ga_add_to_cart_item])
      }

      return
    }

    alert('Det valgte antal er desværre ikke muligt at bestille. Kontakt os gerne hvis der er yderlige spørgsmål.')
  }
}
